module.exports = __webpack_public_path__ + "static/media/trash-undo-alt.c412be1a.svg";